import { useState, useEffect, useContext, useLayoutEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { ConfigContext } from '../../components/Common/ConfigHelper';
import { GlobalContext } from '../../contexts/GlobalContext';
import OtpInput from 'react-otp-input';
import { getDeviceType } from '../Common/CommonHooks';
import iconOtpTrouble from '../../info/Include/images/opt_trouble_icon.svg';

import { Toast } from '../Common/ui-components';
import LoginLoading from '../Common/ui-components/LoginLoading';
import { useAdobeLaunch } from '../Common/utils/adobeLaunch';
import { MissingMobile } from './MissingMobile.js';


export const LoginOTP = ({
    showMsg = false,
    onClickNext,
    invalidOTP,
    setInvalidOTP,
    otp,
    setOtp,
    setIsShowOTPAuth,
    onClickCancelOTP,
    closeBtnEnabled = false,
    getMobile,
    resendOTP,
    isShowOTPToast,
    setIsShowOTPToast,
    setShowLoginLockPopup,
    isVoiceOTP, 
    setIsVoiceOTP,
    isMissingMobile,
    verifyOtpLoading,
}) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { betslipMenu } = useContext(ConfigContext);
    const globalContext = useContext(GlobalContext);
    const [menuInfo, setMenuInfo] = useState(betslipMenu);
    const [changeOtpReciveLoading, setChangeOtpReciveLoading] = useState(false)

    const numericOnly = (event) => {
        if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
    }
    const resendOtpInterval = window.globalConfig.resendOtpInterval;

    // const [otp, setOtp] = useState('');
    const [resent, setResent] = useState(false);
    const [resendTimer, setResendTimer] = useState(resendOtpInterval);
    const [clearOTP, setClearOTP] = useState(true);
    const [accountOpeningURL, setAccountOpeningURL] = useState('#');
    const [isShowAccountOpeningQRCode, setIsShowAccountOpeningQRCode] = useState(false);
    const [isShowTroublePopup, setIsShowTroublePopup] = useState(false);
    const [toastApi, toastContent] = Toast.useToast({ max: 1,showTime:3000,isOTP:true});
    const [hasBeenShowVoiceOTPPopup, setHasBeenShowVoiceOTPPopup] = useState(false);
    const [isClicked,setIsClicked] = useState(false);
    const device = getDeviceType();
    const isFirstRun = useRef(true)
    const isMobile = !device.isTablet && !device.isDesktop
    let mobileStyle = isMobile ? 'is-mobile' : 'is-desktop';
    const endTimestampRef = useRef(0);

    const { sendAdobeEvent } = useAdobeLaunch()

    useEffect(() => {
        if (isMobile) {
            mobileStyle = 'is-mobile'
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobile]);

    useEffect(() => {
        console.debug('init LoginOTP', getMobile().timeout)
        const resendSec = getMobile().timeout || resendOtpInterval;
        endTimestampRef.current = new Date().getTime() + resendSec * 1000;
        setResendTimer(resendSec);
        setResent(true)
        setIsVoiceOTP(false);
    }, []);

    useEffect(() => {
        let interval;
        if (resent) {
          interval = setInterval(() => {
            const now = new Date().getTime();
            const remainingSeconds = Math.max(
                0, 
                Math.ceil((endTimestampRef.current - now) / 1000)
            );
            setResendTimer(remainingSeconds);
          }, 1000);
        }
    
        return () => clearInterval(interval);
    }, [resent]);

    useEffect(() => {
    if (resendTimer === 0) {
        setResent(false);       
    }
    }, [resendTimer]);
    useEffect(()=>{
        if(isShowOTPToast==true){
            if (isVoiceOTP) {
                showIphoneToast();
            } else {
                showToast();
            }
        }
        let close = setTimeout(() => {
            setIsShowOTPToast(false);
        }, 3000);
        return ()=>{
            clearTimeout(close)
        };
    },[isShowOTPToast])
    const handleResendClick = () => {
        if(resent) {
            return
        }
        setInvalidOTP(false)
        setOtp('')
        resendOTP(isVoiceOTP ? 2 : 1);
        const resendSec = getMobile().timeout || resendOtpInterval;
        endTimestampRef.current = new Date().getTime() + resendSec * 1000;
        setResendTimer(resendSec);
        setResent(true);        
        sendAdobeEvent({
            event: "interaction",
            interaction: { eventID: `eWin_CIAM_S1a-OTP${isVoiceOTP?'-Voice':''}-clickResendCode_whitelistWithMobile` }
        });
    };

    const formatResendTimer = () => {
        const minutes = Math.floor(resendTimer / 60);
        const seconds = resendTimer % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    const clearOTPInput = () => {
        if (!invalidOTP || !clearOTP) {
            console.debug('invalidOTP, clearOTP', invalidOTP, clearOTP)
            return;
        }
        setOtp('');
        setClearOTP(false);
        setInvalidOTP(false)
    }

    useEffect(() => {
        if(invalidOTP.length>0){
            if(invalidOTP.includes("ERR"))
                invalidOTP = invalidOTP.replace("ERR",'')
        }
        setClearOTP(true);
        if(invalidOTP=='100014'){
          invalidOTP=""
          setShowLoginLockPopup(true)
          onClickCancelOTP()
        }
    }, [invalidOTP])
    const showToast =()=>{
        toastApi({ message:  t('LB_OTP_RESEND_SUCCESS')});
    }
    const showIphoneToast =()=>{
        toastApi({ message:  t('LB_OTP_IPHONE_RESEND_SUCCESS')});
    }
    useLayoutEffect(() => {
        if (otp.length >= 6) {
          // Manually unfocus the input box
          console.debug('unfocus otp input')
          document.activeElement.blur();
          // check otp
          onClickNext();
        }
      }, [otp]);

    const handleClickAccountOpening = () => {
        const device = getDeviceType();
        // if (device.isTablet && !device.isDesktop ) { // tablet -> QR code
        //     setIsShowAccountOpeningQRCode(true);
        // }
        
        setIsShowAccountOpeningQRCode(true); // testing        
        sendAdobeEvent({
            event: "interaction",
            interaction: { eventID: `eWin_CIAM_S1a-OTP${isVoiceOTP?'-Voice':''}-clickChangeMobile_whitelistWithMobile` }
        });
    };

    useEffect(() => {
        const device = getDeviceType();

        if (device.isTablet) {
            setAccountOpeningURL('#');
        } else if (device.isDesktop) {
            setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_MHKJC'));
        } else {
            setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_SH'));
        }
        // setAccountOpeningURL('#'); // testing
    }, [navigator.platform, navigator.userAgent]);
    const  SH_URL = `${window.globalConfig.SH_URL}/3in1/${lang}/RAO/RAM`
    const handleRedirectToRAO=()=>{
        window.open(SH_URL);
    }
    const handleAccountOpeningCancelBtn = () => {
        setIsShowAccountOpeningQRCode(false);
        onClickCancelOTP();
    }
    const handleResendOTPAnotherOption = async () => {
        setIsClicked(true);
        var stage = null;
        setChangeOtpReciveLoading(true)
        if(isFirstRun.current) {
            //first time resend with voice
            stage = await resendOTP(2, false)
        } else {
            //resend with another option
            stage = await resendOTP(isVoiceOTP? 1:2, false)
        }
        setChangeOtpReciveLoading(false)
        isFirstRun.current = false
        if(stage != null && stage != undefined) {
            setResent(true);
            const resendSec = getMobile().timeout || resendOtpInterval;
            endTimestampRef.current = new Date().getTime() + resendSec * 1000;
            setResendTimer(resendSec);
            setIsShowTroublePopup(false);
            setHasBeenShowVoiceOTPPopup(true);
            setInvalidOTP(false);
            setOtp('');
            setIsVoiceOTP(!isVoiceOTP);
        }
        isFirstRun.current = false
        setIsClicked(false);        
        sendAdobeEvent({
            event: "interaction",
            interaction: { eventID: `eWin_CIAM_S1a-OTP${isVoiceOTP?'-Voice-clickSmsOTP':'-clickVoiceOTP'}_whitelistWithMobile` }
        });
    }

    const onOtpAuthTroubleClick  = () => {
            setIsShowTroublePopup(true);                        
            sendAdobeEvent({
                event: "interaction",
                interaction: { eventID: 'eWin_CIAM_S1a-OTP-clickTrouble_whitelistWithMobile' }
            });
    }

    return (
        <>
      
        <Popup open={showMsg}  closeOnEscape={false} closeOnDocumentClick={false} className={`comingSoonLogOutDialog logout-succ-msg otp-popup otp-popup-content  ${invalidOTP ? 'otp-invalid' : ''} ${mobileStyle}`}>
            {!isShowTroublePopup?
            <div className={`otp-popup-container ${invalidOTP ? 'otp-invalid' : ''} ${window.globalConfig.useOTPPrefix?'otp-popup-container-2_2':''}`}>
                {toastContent}
                {
                    verifyOtpLoading && <LoginLoading className='login-center'></LoginLoading>
                }
                <div className="otp-title" id="AuthTitle">{t('LB_OTP_0')}</div>
                <div className="otp-1" id="Auth_content_prompt" dangerouslySetInnerHTML={{ __html: t(isVoiceOTP? 'LB_OTP_8' :'LB_OTP_1') + `<b>${getMobile()?.mobileNo}</b>`}} ></div>
                <div className="otp-pleaseinput" id="code_label">{t('LB_OTP_5')}</div>
                
                <div id="code_input_box" style={window.globalConfig.useOTPPrefix?{
                    display: 'flex',
                    alignItems: 'center'
                }:{}}>
                    {window.globalConfig.useOTPPrefix&&<div style={{
                        paddingRight: '5px',
                        fontSize: '14px',
                        fontWeight: 600,
                        marginTop:'8px',
                        whiteSpace:'nowrap'

                    }}>
                         <span>{getMobile()?.prefixCode + ' -'}</span>
                    </div>}
                    <OtpInput
                        value={otp}
                        onChange={(o) => {
                            setInvalidOTP(false)
                            setOtp(o)
                        }}
                        numInputs={6}
                        renderInput={(props) => <input onClick={clearOTPInput} onContextMenu={(e) => e.preventDefault()} {...props} />}
                        containerStyle="d-flex mt-2 gap-2"
                        inputStyle={` otp-input ${!invalidOTP || !clearOTP ? '' : 'otp-input-invalid'} ${window.globalConfig.useOTPPrefix?'otp-input-2_2':''}`}
                        shouldAutoFocus={true}
                        inputType={'number'}
                    />
                    
                </div>
                {invalidOTP && <div
                    className='otp-invalid-code'
                    id="code_tips"
                    dangerouslySetInnerHTML={{
                        __html: t('LB_OTP_ERR'+invalidOTP)
                    }}
                />}
                
                <div className="otp-didnotreceive" id="code_resend_ask">{t(isVoiceOTP? 'LB_OTP_9' :'LB_OTP_6')}</div>
                <div 
                    className={`otpauth-button ${resent ? 'resent' : ''}`}
                    onClick={handleResendClick}
                    id="code_resend"
                >
                    <span>{t(isVoiceOTP? 'LB_OTP_10': 'LB_OTP_7')}</span>
                    {resent && <span> ({formatResendTimer()})</span>}
                </div>
                
                <div className="otpauth-trouble">
                    <img onClick={onOtpAuthTroubleClick} className='img-trouble' src={iconOtpTrouble} alt="" />
                    <div>
                        {isVoiceOTP ?
                        <div onClick={onOtpAuthTroubleClick} className='otpauth-trouble-iconBox'>
                            {t( 'LB_OTP_TROUBLE_CHANGE3')}
                        </div>: 
                        <div onClick={onOtpAuthTroubleClick} className='otpauth-trouble-iconBox'>
                            {t('LB_OTP_TROUBLE_CHANGE1')}
                        </div> }
                        <span onClick={onOtpAuthTroubleClick} > 
                            {t('LB_OTP_TROUBLE_CHANGE2')}
                        </span>
                    </div>                   
                </div>
               
                {/* <div className="otpauth-change-mobile mt-4">{t('LB_OTP_CHANGE_MOBILE')}</div>
                <div className="otpauth-button"><a href={accountOpeningURL} target={accountOpeningURL === '#' ? '' : "_blank"} onClick={handleClickAccountOpening}>{t('LB_OTP_CHANGE_MOBILE_BTN')}</a></div>
                <div className="otpauth-change-mobile-msg" id="Auth_content_notice">{t('LB_OTP_CHANGE_MOBILE_MSG')}</div>

                <div className="otpauth-change-mobile mt-4" id="Verify_loginAnswer">{t('LB_OTP_VERIFY_BY_EKBA')}</div>
                <div className="otpauth-button" onClick={onClickEKBA}>{t('LB_OTP_VERIFY_BY_EKBA_BTN')}</div> */}

                <div className="otpauth-button otpauth-cancel mt-3" onClick={onClickCancelOTP} id="Cancel">{t('LB_OTP_CANCEL')}</div>

            </div>
            :
           
                <div className='otp-trouble'>
                      {
                   (changeOtpReciveLoading) && <LoginLoading className='login-center'></LoginLoading>
                    }
                    <div className='otp-acopening-title' id='having_trouble'>{t('LB_OTP_TROUBLE')}</div>
                    <div className='otp-trouble-container'>
                        {
                            window.globalConfig.useVoiceOTP &&  <div className={`otp-trouble-message ${(resent && hasBeenShowVoiceOTPPopup) ? 'disable' : ''}`} id="voice_call"  onClick={()=> {
                                if (resent && hasBeenShowVoiceOTPPopup) {
                                    return;
                                }
                                if(!isClicked) {
                                    handleResendOTPAnotherOption();
                                }
                            }}>
                                {t(isVoiceOTP?'LB_OTP_TROUBLE_OPT_TO_SMS':'LB_OTP_TROUBLE_OPT_VOICE_CALL')}
                                {(resent && hasBeenShowVoiceOTPPopup) && <span className="countdown"> ({formatResendTimer()})</span>}
                            </div>
                        }                      
                        <div className='otp-trouble-message' onClick={handleClickAccountOpening} id="changed_mobile">{t('LB_OTP_TROUBLE_OPT1')}</div>
                        <div className='otp-trouble-tips'>
                            {
                                <Trans
                                    values={{
                                        url: window.globalConfig.M_URL
                                    }}
                                    i18nKey="LB_OTP_TROUBLE_OPT_VISIT_WEB"
                                    components={{ a: <a target="_blank"/>, br: <br /> }}
                                />
                            }
                        </div>
                    </div>
                    <div className='otp-trouble-group'>
                        <span className='cancel-btn' id="back" onClick={()=>{
                                setIsShowTroublePopup(false);
                            }}>{t('LB_OTP_BACK_TO_OTP')}
                        </span>
                    </div>
                </div>

            }
            {
            isShowAccountOpeningQRCode && <MissingMobile 
                isMissingMobile={isShowAccountOpeningQRCode}
                shouldCloseOnEsc={false}
                onClose={() => {setIsShowAccountOpeningQRCode(false);}}
                setIsShowAccountOpeningQRCode={setIsShowAccountOpeningQRCode}
                onClickCancelOTP={onClickCancelOTP}
                closeBtnEnabled={closeBtnEnabled}
                type="update"
            />}
        </Popup>
        </>
    );
};